

var menuTriggers = jQuery(".shop-header, .menu-header, .menu-close, .menu-overlay");
var menuActiveTargets = jQuery("body, .site-header, .butterfly-header, .about-header, .menu-header, .site-header__cart, .site-header__logo-image, .menu-wrap, .menu-overlay, .menu-close");

menuTriggers.click(function(){
  menuActiveTargets.toggleClass("menu-active");
  menuTriggers.toggleClass("menu-active");
});

jQuery("#accordion-product h3.one").on('click', function(){
  jQuery('.circle-plus.one').toggleClass('opened');
});
jQuery("#accordion-product h3.two").on('click', function(){
  jQuery('.circle-plus.two').toggleClass('opened');
});
jQuery("#accordion-product h3.three").on('click', function(){
  jQuery('.circle-plus.three').toggleClass('opened');
});
jQuery("#accordion-product h3.four").on('click', function(){
  jQuery('.circle-plus.four').toggleClass('opened');
});

function _setAnimatedImage($els){
  jQuery.each($els, function (i, el) {
    var number = parseInt(Math.random() * 1000),
        $el = jQuery(el),
        animated = $el.data().animation.animated + number,
        end = $el.data().animation.end;
    
    $el.addClass('animation-finished-scroll');
    $el.attr('src', animated);
    
    setTimeout(function () {
      $el.attr('src', end);
    }, 2000);
  });
}

function _setupAnimations ($context) {    
  var $animatedElements = jQuery('[data-animation]', $context);
  if($animatedElements.length == 0) return;
  jQuery(window)  
  .scroll(function (event) {
    var imageTopPos = $context.parent().position().top - ($context.parent().height() - 200);
	var scrollTop = jQuery(window).scrollTop();
    if(scrollTop >= imageTopPos){
		_setAnimatedImage($animatedElements.filter(':not(.animation-finished-scroll)'));
    }
  });  
}

jQuery(function () {    
  var $context = jQuery('.home-rtp-01');//as-featured-on-product
  if($context.length > 0) _setupAnimations ($context);
});


//  Lazy Load animated Gifs that only loop once 

!function(window){
  var $q = function(q, res){
        if (document.querySelectorAll) {
          res = document.querySelectorAll(q);
        } else {
          var d=document
            , a=d.styleSheets[0] || d.createStyleSheet();
          a.addRule(q,'f:b');
          for(var l=d.all,b=0,c=[],f=l.length;b<f;b++)
            l[b].currentStyle.f && c.push(l[b]);

          a.removeRule(0);
          res = c;
        }
        return res;
      }
    , addEventListener = function(evt, fn){
        window.addEventListener
          ? this.addEventListener(evt, fn, false)
          : (window.attachEvent)
            ? this.attachEvent('on' + evt, fn)
            : this['on' + evt] = fn;
      }
    , _has = function(obj, key) {
        return Object.prototype.hasOwnProperty.call(obj, key);
      }
    ;

  function loadImage (el, fn) {
    var img = new Image()
      , src = el.getAttribute('data-src');
    img.onload = function() {
      if (!! el.parent)
        el.parent.replaceChild(img, el)
      else
        el.src = src;

      fn? fn() : null;
    }
    img.src = src;
  }

  function elementInViewport(el) {
    var rect = el.getBoundingClientRect()

    return (
       rect.top    >= 0
    && rect.left   >= 0
    && rect.top <= (window.innerHeight || document.documentElement.clientHeight)
    )
  }

    var images = new Array()
      , query = $q('img.lazygif')
      , processScroll = function(){
          for (var i = 0; i < images.length; i++) {
            if (elementInViewport(images[i])) {
              loadImage(images[i], function () {
                images.splice(i, i);
              });
            }
          };
        }
      ;
    // Array.prototype.slice.call is not callable under our lovely IE8 
    for (var i = 0; i < query.length; i++) {
      images.push(query[i]);
    };

    processScroll();
    addEventListener('scroll',processScroll);
    var element = document.getElementsByClassName("lazygif");
    if(element && element.classList) element.classList.remove("lazygif");

}(this);